import { jsx as _jsx } from "react/jsx-runtime";
import slugify from 'slugify';
export const Heading = (props) => {
    let { id, level, ...rest } = props;
    if (!id && typeof props.children === 'string') {
        id = slugify(props.children, {
            lower: true,
            strict: true,
        }).replaceAll(/(^\d)|[^a-zA-Z0-9-_]/g, '');
    }
    const H = `h${level}`;
    return (_jsx(H, { id: id, ...rest, children: props.children }));
};
